























export default
  name: 'EventTaskList'
  props: ['event', 'routes', 'showEnhancements']
  computed:
    enhancementFields: ->
      return (@event.form_fields?.filter (f) => !@event.required_fields.includes(f))
    hasMissingRequiredFields: -> return @event.missing_required_fields.length > 0
    requiredFields: -> return @event.required_fields
  methods:
    fieldIsMissing: (fields) ->
      missing = false
      missing = @event.missing_form_fields.includes(fields) if !Array.isArray(fields)
      missing ||= @event.missing_form_fields.includes(field) for field in fields if Array.isArray(fields) 
      missing
    navigateToField: (field) -> @$parent.saveWizard(@routes[field])
    formattedNameForField: (field) ->
      mapping = 
        name: 'Event Name'
        description: 'Event Description'
        streaming_platforms: 'Streaming Platforms'
        types: 'Event Types'
        starts_at: 'Start Time'
        ends_at: 'End Time'
        reach: 'Attendance'
        live_stream: 'Live Streaming'
        physical_event: 'Physical Event'
        viewers: 'Viewers'
        venue_name: 'Venue Name'
        venue_street: 'Venue Street'
        venue_city: 'Venue City'
        venue_state: 'Venue State'
        venue_zip: 'Venue Zip'
        space: 'Available Sponsorships'
        schedule_confirmed: 'Date Confirmation'
        photos: 'Photo Upload'
        sales_prohibited: 'Sales Allowed'
        can_collect_student_data: 'Data Collection'
        food_can_be_distributed: 'Food Distribution'
        drink_can_be_distributed: 'Drink Distribution'
      mapping[field]

